import { api } from '../api';

const getNewVehicleRequestList = async ({
  pageNumber = 1,
  pageSize = 10,
  customerId = null,
  filter = null,
}) => {
  const data = {
    page: pageNumber,
    pageSize,
    customerId,
    filter,
  };
  const response = await api({
    url: `Vehicles/GetNewVehicleRequestList`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data,
    params: null,
  });
  return response.data;
};

const sendSmsDriver = async ({ plate, providerType }) => {
  const data = {
    plate,
    providerType,
  };
  const response = await api({
    url: `Vehicles/sendSmsDriver`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data,
    params: null,
  });
  return response.data;
};

const newCarDemands = {
  getNewVehicleRequestList,
  sendSmsDriver,
};

export default newCarDemands;
